import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function SportsBaseballIcon(props: IconProps) {
    return <Icon {...props} iconKey={"sports_baseball"}/>
}
